export default __webpack_public_path__ + "static/media/whirlpool.3549feaf.svg";